export const COMMODITY_GETALL = "COMMODITY_GETALL";

export const COMMODITY_GETALL_PENDING = "COMMODITY_GETALL_PENDING";

export const COMMODITY_GETALL_SUCCESS = "COMMODITY_GETALL_SUCCESS";

export const COMMODITY_GETALL_ERROR = "COMMODITY_GETALL_ERROR";

export const VENDOR_COMMODITY_SAVE = "VENDOR_COMMODITY_SAVE";

export const VENDOR_COMMODITY_SAVE_PENDING = "VENDOR_COMMODITY_SAVE_PENDING";

export const VENDOR_COMMODITY_SAVE_SUCCESS = "VENDOR_COMMODITY_SAVE_SUCCESS";

export const VENDOR_COMMODITY_SAVE_ERROR = "VENDOR_COMMODITY_SAVE_ERROR";

export const COMMODITY_CHECK_DUPLICATE = "COMMODITY_CHECK_DUPLICATE";

//export const COMMODITY_VALIDATION_ERROR = "COMMODITY_VALIDATION_ERROR";

export const COMMODITY_SAVE = "COMMODITY_SAVE";

export const COMMODITY_SAVE_ERROR = "COMMODITY_SAVE_ERROR";

export const COMMODITY_SAVE_SUCCESS = "COMMODITY_SAVE_SUCCESS";

export const COMMODITY_SAVE_PENDING = "COMMODITY_SAVE_PENDING";

// EDIT
export const COMMODITY_GET = "COMMODITY_GET";

export const COMMODITY_GET_SUCCESS = "COMMODITY_GET_SUCCESS";

export const COMMODITY_GET_ERROR = "COMMODITY_GET_ERROR";

export const COMMODITY_GET_PENDING = "COMMODITY_GET_PENDING";
